<template>
  <icon-font
    v-if="show"
    class="revoked-icon"
    type="icon-yichexiao"
    :size="size"
  />
</template>

<script lang="ts" setup>
  defineOptions({
    // 撤销盖章，使用时将其父元素设置为position: relative;
    name: 'IsRevoked',
  });
  defineProps({
    show: {
      type: Boolean,
      default: false,
    },
    size: {
      type: [Number, String],
      default: 150,
    },
    top: {
      type: [Number, String],
      default: 0,
    },
    right: {
      type: [Number, String],
      default: 0,
    },
  });
</script>

<style lang="less" scoped>
  .revoked-icon {
    position: absolute;
    top: v-bind(top);
    right: v-bind(right);
    z-index: 9;
  }
</style>
